import React from 'react';
import { Button, Checkbox, Modal } from 'antd';
import { formatCents } from '../derive';
import { ADV_COST_COPY, COST_MODAL_COPY, OTHER_PRIMARY_COPY } from '../copy';
import s from '../s.module.less';

type Props = {
    open: boolean;
    // check = 常规 $0.25；advanced = 目录搜索 $1.50；other = 失败后查档案上的另一张 primary（$0.25，
    // 正文点名「另一张」）。都只对 manual persona 弹（enrolled 全免费）
    mode: 'check' | 'advanced' | 'other';
    carrier: string;
    // 本月已累计（美分）；> 0 才渲染累计行
    monthToDateCents: number;
    priceCents: number;
    onCancel: () => void;
    // dontAskAgain 由调用方持久化（advanced 模式不提供该选项——最贵的一次点击不该被跳过）
    onConfirm: (dontAskAgain: boolean) => void;
    // 批准花钱之后还有设置步骤（缺 NPI/payer ID）时传 "Next"——按钮是对下一次点击的承诺，
    // 后面还有两个弹窗时说 "Run check" 只兑现一半（原型 08/19）。advanced 不受影响
    runLabel?: string;
    // practice 视图：check 以归属 provider 身份执行，累计行/落账文案不再说 "Your"
    practiceView?: boolean;
    // other 模式查的是次保险：正文点名 secondary
    targetIsSecondary?: boolean;
};

const CostConfirmModal: React.FC<Props> = ({
    open,
    mode,
    carrier,
    monthToDateCents,
    priceCents,
    onCancel,
    onConfirm,
    runLabel,
    practiceView,
    targetIsSecondary,
}) => {
    const [dontAsk, setDontAsk] = React.useState(false);
    const adv = mode === 'advanced';

    React.useEffect(() => {
        if (open) setDontAsk(false);
    }, [open]);

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            title={adv ? ADV_COST_COPY.title : COST_MODAL_COPY.title}
            width={420}
            wrapClassName={s.eligModalScope}
            footer={
                <div className={s.costFooter}>
                    {!adv ? (
                        <Checkbox checked={dontAsk} onChange={(e) => setDontAsk(e.target.checked)}>
                            {COST_MODAL_COPY.dontAsk}
                        </Checkbox>
                    ) : (
                        <span />
                    )}
                    <div className={s.costFooterBtns}>
                        <Button onClick={onCancel}>{COST_MODAL_COPY.cancel}</Button>
                        <Button type="primary" onClick={() => onConfirm(!adv && dontAsk)}>
                            {adv ? ADV_COST_COPY.run : runLabel || COST_MODAL_COPY.run}
                        </Button>
                    </div>
                </div>
            }
        >
            <div className={s.costBody}>
                {adv && ADV_COST_COPY.body(carrier)}
                {mode === 'other' && OTHER_PRIMARY_COPY.costBody(carrier, targetIsSecondary)}
                {mode === 'check' && COST_MODAL_COPY.body(carrier)}
            </div>
            <div className={s.costBox}>
                <div className={s.costRow}>
                    <span>{adv ? ADV_COST_COPY.label : COST_MODAL_COPY.thisCheck}</span>
                    <span className={s.costAmt}>{formatCents(priceCents)}</span>
                </div>
                {monthToDateCents > 0 && (
                    <div className={s.costRow}>
                        <span>
                            {practiceView ? COST_MODAL_COPY.runningTotalPractice : COST_MODAL_COPY.runningTotal}
                        </span>
                        <span className={s.costAmt}>{formatCents(monthToDateCents + priceCents)}</span>
                    </div>
                )}
                <div className={s.costFoot}>{practiceView ? COST_MODAL_COPY.footPractice : COST_MODAL_COPY.foot}</div>
            </div>
        </Modal>
    );
};

export default CostConfirmModal;
